import { type PropsValue } from 'react-select';

import { type OptionType } from '@hivebrite/design-system/Inputs';

import { isOptionType } from './isOptionType';

type ValueType =
  | Array<number>
  | Array<object>
  | PropsValue<OptionType>
  | number
  | object
  | null;

/**
 * Checks if the value is already in OptionType format
 */
export const isAlreadyOptionType = (
  value: ValueType,
): value is Array<OptionType> | OptionType => {
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    return isOptionType(value);
  }

  if (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every((v) => typeof v === 'object' && v !== null && isOptionType(v))
  ) {
    return true;
  }

  return false;
};
